import { twMerge } from 'tailwind-merge';

export type ClassValue = string | false | null | undefined;

/**
 * Joins class names and resolves Tailwind conflicts so that later classes win
 * (`cn('px-6', 'px-8')` → `'px-8'`). Lets callers override kit defaults via `className`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(inputs.filter(Boolean).join(' '));
}
